import { produce, Draft } from 'immer';
import { StateCreator } from 'zustand';
import { Store } from 'store';

// Zustand middleware to make Immer integration cleaner
// Copied from: https://github.com/pmndrs/zustand#middleware
const immerMiddleware =
  <T extends Store>(config: StateCreator<T>): StateCreator<T> =>
  (set, get, api) =>
    config(
      (partial, replace) => {
        const nextState =
          typeof partial === 'function'
            ? produce(partial as (state: Draft<T>) => T)
            : (partial as T);
        return set(nextState, replace);
      },
      get,
      api
    );

export default immerMiddleware;
